export default {
  getStockItem: (state) => state.stockItem,
};
